module.exports = __webpack_public_path__ + "img/SKLB-Aviso 3.33c13066.png";